<template>
  <BaseModal class="brand-modal" v-model="isOpenModal">
    <FileSelector
      v-model="showFileSelector"
      type="assets"
      subcategory="image_brand"
      @fileUploaded="fileUploaded"
      @selectedFile="fileUploaded"
    />
    <template v-slot:header v-if="brand">
      {{ brand.nameShow }}
    </template>
    <div class="navigation">
      <div class="bar">
        <button
          @click="selectedSection = 'details'"
          class="tablinks"
          :class="{ active: selectedSection == 'details' }"
        >
          Details
        </button>
      </div>
    </div>
    <div class="content-brand-edit" v-if="selectedSection == 'details'">
      <template v-if="!loadingSaving">
        <template v-if="brandToUpdate">
          <div class="input-set">
            <div class="input-item">
              <label for="brand-name">Name to show</label>
              <input
                id="brand-name"
                type="text"
                class="regular clear"
                v-model="brandToUpdate.nameShow"
              />
            </div>
            <div class="input-item">
              <label for="brand-name-base">Name on part</label>
              <input
                id="brand-name-base"
                type="text"
                class="regular clear"
                v-model="brandToUpdate.name"
              />
            </div>
            <div class="input-item">
              <label for="brand-avg">AVG</label>
              <input
                id="brand-avg"
                type="number"
                class="regular clear"
                v-model="brandToUpdate.avg"
              />
            </div>
            <div class="input-item">
              <label for="brand-keywords">Keywords</label>
              <input
                id="brand-keywords"
                type="text"
                class="regular clear"
                v-model="brandToUpdate.keywords"
              />
            </div>
            <div class="input-item">
              <label for="brand-type">Type</label>
              <select
                id="brand-type"
                class="regular clear"
                v-model="brandToUpdate.type"
              >
                <option value="" disabled>Select type</option>
                <option value="Aftermarket">Aftermarket</option>
                <option value="Original">Original</option>
                <option value="OEM">OEM</option>
              </select>
            </div>
            <div class="input-item">
              <label for="brand-url">URL</label>
              <input
                id="brand-url"
                type="text"
                class="regular clear"
                @keyup="cleanBrandUrl()"
                v-model="brandToUpdate.url"
              />
            </div>
            <div class="input-item">
              <label for="status">Status</label>
              <BaseSwitchCustom id="status" v-model="brandToUpdate.status" />
            </div>
          </div>
          <div class="input-item brand-image-box">
            <template v-if="loadingImage">
              <BaseSmallSpinner />
            </template>
            <template v-else>
              <template v-if="brandToUpdate.image != null">
                <div class="action-icons">
                  <a
                    :href="brandToUpdate.image"
                    target="_blank"
                    class="delete-icon"
                  >
                    <img src="@/assets/icons/eye.svg" />
                  </a>
                  <a
                    @click="deleteBrandImage()"
                    class="icon delete-icon"
                    v-if="brandToUpdate.image == brand.image"
                  >
                    <img src="@/assets/icons/trash.svg" />
                  </a>
                  <a
                    @click="showFileSelector = true"
                    class="icon delete-icon"
                    v-else
                  >
                    <img src="@/assets/icons/edit.svg" />
                  </a>
                </div>
                <img class="brand-image" :src="brandToUpdate.image" />
              </template>
              <template v-else>
                <a @click="showFileSelector = true" class="image-upload-link">
                  <img
                    src="@/assets/icons/upload-clear.svg"
                    alt="upload-image"
                  />
                  Upload Image
                </a>
              </template>
            </template>
          </div>
          <div class="input-item brand-image-box w-full">
            <label for="brand-description">Description</label>
            <VueEditor
              id="brand-description"
              cols="5"
              class="regular clear w-full"
              v-model="brandToUpdate.description"
            >
            </VueEditor>
          </div>
          <div class="end">
            <div class="actions" v-if="changesPending">
              <button @click="discardChanges()" class="btn-dark-button">
                Discard changes
              </button>
              <button @click="confirmChanges()" class="btn-success-button">
                Confirm Changes
              </button>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <BaseSmallSpinner />
      </template>
    </div>
  </BaseModal>
</template>
<script>
import FileSelector from "@/components/FileSelector.vue";
import { createBrand, updateBrand } from "@/api/store/BrandsService.js";
import { VueEditor } from "vue2-editor";

export default {
  name: "BrandModal",
  components: {
    FileSelector,
    VueEditor
  },
  data() {
    return {
      isOpenModal: true,
      brandToUpdate: null,
      selectedSection: "details",
      loadingImage: false,
      showFileSelector: false,
      subCategories: [],
      loadingSaving: false
    };
  },
  props: {
    brand: {
      type: Object,
      required: true
    }
  },
  computed: {
    changesPending() {
      return !(
        JSON.stringify(this.brandToUpdate) == JSON.stringify(this.brand)
      );
    }
  },
  watch: {
    isOpenModal(val) {
      if (!val) {
        this.$emit("closedBrandEdition");
      } else {
        this.subCategories = [];
      }
    },
    brand(val) {
      this.brandToUpdate = { ...val };
    },
    selectedSection(val) {
      if (val == "subcategories") {
        this.loadSubcategories();
      }
    }
  },
  mounted() {
    this.brandToUpdate = { ...this.brand };
  },
  methods: {
    cleanBrandUrl() {
      this.brandToUpdate.url = this.brandToUpdate.url
        .replace(/[ -]/g, "_")
        .replace(/\W/g, "")
        .toLowerCase();
    },
    createdSubbrand(subCategory) {
      this.subCategories.unshift(subCategory);
    },
    updatedSubbrand(subCategory) {
      const i = this.subCategories.findIndex(x => {
        return x.id == subCategory.id;
      });
      this.subCategories[i] = { ...subCategory };
    },
    async deleteBrandImage() {
      this.brandToUpdate.image = null;
    },
    fileUploaded(file) {
      this.brandToUpdate.image = file.s3Url;
    },
    discardChanges() {
      this.brandToUpdate = { ...this.brand };
    },
    async confirmChanges() {
      //TODO - add form validation
      if (!this.brandToUpdate.url) {
        alert("the url can't be empty");
        return;
      }
      if (this.brand.id == null) {
        let res = await createBrand(this.brandToUpdate);
        if (res.status == "success") {
          this.$emit("createdBrand", res.brand);
          let message = "brand created";
          this.$toast.open({
            message: message,
            type: "success",
            position: "top-right"
          });
        } else {
          this.$toast.open({
            message: `Error creating brand`,
            type: "error",
            position: "top-right"
          });
        }
      } else {
        let res = await updateBrand(this.brand.id, this.brandToUpdate);
        if (res.status == "success") {
          this.$emit("updatedBrand", res.brand);
          let message = "brand updated";
          this.$toast.open({
            message: message,
            type: "success",
            position: "top-right"
          });
        } else {
          this.$toast.open({
            message: `Error updating brand`,
            type: "error",
            position: "top-right"
          });
        }
      }
    },
    subbrandDeleted(subbrand) {
      this.subCategories = this.subCategories.filter(x => {
        return x.id != subbrand.id;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content-brand-edit {
  padding: 20px 30px !important;
  max-width: 90%;
  margin: 0 auto;
  .input-set {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 20px;
  }
  .end {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    text-align: right;
  }
  .input-item {
    margin: 10px 10px;
    display: flex;
    flex-direction: column;
    label {
      margin-bottom: 10px;
    }
    &.brand-image-box {
      width: fit-content;
      margin: 0 auto;
      position: relative;
      padding: 25px;
      .action-icons {
        position: absolute;
        top: 0px;
        right: 0px;
        display: flex;
        flex-direction: row;
        .icon {
          margin-left: 10px;
        }
        .delete-icon {
          width: 25px;
          height: 25px;
          img {
            width: 100%;
          }
        }
      }
      .brand-image {
        width: 100px;
        height: auto;
        margin: 0 auto;
      }
    }
  }
  .image-upload-link {
    display: flex;
    flex-direction: column;
    img {
      width: 100px;
    }
  }
}
.content-subbrand-edit {
  width: 100%;
  padding: 20px;
  height: 600px;
  overflow-y: auto;
}
</style>
